import {Injectable} from '@angular/core';
import { USER_LOCAL_STORAGE_KEY } from '../../app.constants';
import {decrypt, encrypt} from '../utils/crypto.util';

@Injectable({
    providedIn: 'root'
})
export class StorageService {

    constructor() {
    }

    save(key: string, data: any) {
        try {
            localStorage.setItem(key, encrypt(JSON.stringify(data)));
        } catch (e) {
            console.error(e);
        }
    }

    get(key: string) {
        try {
            return JSON.parse(decrypt(localStorage.getItem(key)));
        } catch (e) {
            return null;
        }
    }

    remove(key: string) {
        localStorage.removeItem(key);
    }

    clear() {
        localStorage.removeItem(USER_LOCAL_STORAGE_KEY);
    }

}
